import React from "react";
import Skills from "./Skills.js";
import Tilt from "react-parallax-tilt";
import Lottie from "lottie-react";
import Coder from "../LottieFiles/coder.json";

const About = () => {
  return (
    <>
      <div className="AboutPage">
        <div className="AboutText">
          <h1 className="AboutTextHeading">
            <b>About</b> me!
          </h1>
          <p>
            <p>
              {" "}
              Hello, I'm Rudy. 
              <br/><br/>
              With 7 years of experience, I am a seasoned full-stack developer proficient in the MERN stack, Next.js, Vue.js, React Native, Laravel, and more.  
              I specialize in developing robust web applications using the MERN stack, ensuring efficient data management and creating intuitive user interfaces.  
              When it comes to mobile app development, I leverage React Native to build cross-platform applications for both iOS and Android platforms. Moreover, I possess expertise in Laravel, empowering me to develop efficient back-end solutions encompassing complex business logic and RESTful APIs. 
              <br/>
              Let's work together to bring your visions to life!
            <br />
            </p>
          </p>
        </div>

        <div>
          <Tilt>
            {/* <Lottie
              className="illustration"
              animationData={Coder}
              loop={true}
            /> */}
            <img src="/images/me.jpg" width={300} className="about_img" />
          </Tilt>
        </div>
      </div>
    </>
  );
};

export default About;
